import React, { Component } from 'react';
import { Image, Col, Row, Container, Button, Carousel } from 'react-bootstrap';
import Computadora from '../../../img/NewPNG/Banner inicial_imagen.png';
import VisaLogo from '../../../img/visa_logo.png';
import CarouselMe from './components/carousel';
import MasterLogo from '../../../img/mastercard_logo.png';
import C_Bitcoin from '../../../img/Cryptomonedas/Bitcoin.svg';
import C_Litecoin from '../../../img/Cryptomonedas/Litecoin.svg';
import C_Etherum from '../../../img/Cryptomonedas/Eth.svg';
import C_XRP from '../../../img/Cryptomonedas/XRP.svg';
import C_Dash from '../../../img/Cryptomonedas/Dash.svg';
import BitcoinBanner from '../../../img/bitcoin_star.png';
import Translate from '../../../../../translate';
import './index.css';
import { BannerApi, BannerTarjeta, PagoServicios, BannerThatsit } from "./components/sectionCarousel";

class PrincipalBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      coinsIMG:[
        {img:C_Bitcoin,coin:'Bitcoin'},
        {img:C_Litecoin,coin:'Litecoin'},
        {img:C_Etherum,coin:'Etherum'},
        {img:C_XRP,coin:'XRP'},
        {img:C_Dash,coin:'Dash'}
      ],
    }
  }

  handleSelect = (selectedIndex) => {
    this.setState({index: selectedIndex})
  };

  getBackground = (indexCarousel) => {
    switch (indexCarousel) {
      case 0:
        return "bannerBackground section-container";
      case 1:
        return "api-background section-container";
      case 2: 
        return "tarjeta-background section-container";
      case 3: 
        return "thatsit-background section-container";
      case 4: 
        return "servicios-background section-container";
    }
  }

  render() {
    const { index } = this.state;
    return (
      <div className={this.getBackground(index)} id='nosotros'>
        <Carousel
          activeIndex={index}
          onSelect={this.handleSelect}
          indicators={false}
          interval={4000}
        >
          <Carousel.Item>
            <div className='comisiones-outter'>
              <div className='banner-position'>
                <Image src={Computadora} className='banner-image' />
                <Image src={BitcoinBanner} className='bitcoin-left'/>
              </div>
              <Container>
                <Row>
                  <Col xl={6} lg={6}>
                    <p className='align-title-mobile'>
                      <span className='bannerTitle'>{Translate[this.props.lan].landing3.banner.titulo}</span>
                    </p>
                    <p className='bannerSubtitle'>{Translate[this.props.lan].landing3.banner.subtitulo}</p>
                    <div className='row-logos'>
                      <Button className='btn-banner' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{Translate[this.props.lan].landing3.boton}</Button>
                    </div>
                    {/* <div className='row-logos'>
                      <Image src={VisaLogo} className='brandImg'/>
                      <Image src={MasterLogo} className='brandImg' />
                    </div> */}
                  </Col>
                </Row>
              </Container>
              <div className='banner-position-mobile'>
                <Image src={Computadora} className='banner-image-mobile'/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <BannerTarjeta lan={this.props.lan}/>
          </Carousel.Item>
          <Carousel.Item>
            <BannerApi lan={this.props.lan}/>
          </Carousel.Item>
          <Carousel.Item>
            <PagoServicios lan={this.props.lan}/>
          </Carousel.Item>
          <Carousel.Item>
            <BannerThatsit lan={this.props.lan}/>
          </Carousel.Item>
        </Carousel>
        <Row className='ContainerCoin carouselSpacing'>
          <CarouselMe coins={this.state.coinsIMG}/>
        </Row>
      </div>
    );
  }
}

export default PrincipalBanner;